<!-- vertical 竖 -->
<template>
  <div style="padding: 0 20px 20px 20px">
    <el-row :gutter="10" style="margin-top: 10px">
      <!-- 左侧数据显示 -->
      <el-col :lg="14" :md="14" :sm="24" :xl="14" :xs="24">
        <div class="base-info">
          <div class="card-title">Your Party Info</div>
          <div class="card">
            <div class="flex space_between is-hidden-mobile">
              <div>{{ form.first_name }} {{ form.last_name }}</div>
              <div class="flex">
                {{
                form.payment_id.indexOf("deposit") > -1
                ? "deposit"
                : "pay in full"
                }}
                <span v-if="form.payment_id.indexOf('deposit') > -1" class="ml10">
                  ${{ getPartyPrice() }}
                </span>
                <div class="flex ml10" v-else>
                  <div class="flex" v-if="activity_discount.discount">
                    <span class="discount_price">${{
                      paymentInfo &&
                      (
                      (getPartyPrice() *
                      (100 - activity_discount.discount)) /
                      100
                      ).toFixed(2)
                      }}</span>
                    <span class="org_price">${{ getPartyPrice() }}</span>
                    <div class="discount">
                      -{{ activity_discount.discount }}%
                    </div>
                  </div>
                  <span v-else> ${{ getPartyPrice() }} </span>
                </div>
              </div>
            </div>
            <div class="is-hidden-tablet">
              <div>{{ form.first_name }} {{ form.last_name }}</div>
              <div>
                {{
                form.payment_id.indexOf("deposit") > -1
                ? "deposit"
                : "pay in full"
                }}
              </div>
              <div class="flex">
                <span v-if="form.payment_id.indexOf('deposit') > -1" class="mr10">
                  ${{ getPartyPrice() }}
                </span>
                <div class="flex mr10" v-else>
                  <div class="flex" v-if="activity_discount.discount">
                    <span class="discount_price">${{
                      paymentInfo &&
                      (
                      (getPartyPrice() *
                      (100 - activity_discount.discount)) /
                      100
                      ).toFixed(2)
                      }}</span>
                    <span class="org_price">${{ getPartyPrice() }}</span>
                    <div class="discount">
                      -{{ activity_discount.discount }}%
                    </div>
                  </div>
                  <span v-else> ${{ getPartyPrice() }} </span>
                </div>
              </div>
              <hr color="#eee" size="0.5" style="margin: 5px 0px;" />
            </div>
            <div>{{ form.phone }}</div>
            <div>{{ form.email }}</div>
            <div>
              {{ detail && detail.title }} {{ book_date_mm }}
              {{ checkTimeText }}
            </div>
            <div>Birthday Child's Name：{{ form.birthday_child_name }}</div>
            <div>
              Would you like us to provide cups, plates, and utensils?
              {{ getProvideInfoTitle() }}
            </div>
            <div>
              Select tablecloth color：{{ getTableclothColorInfoColor() }}
            </div>
          </div>
        </div>
        <!-- form.payment_id == 0 是定金 -->
        <div>
          <div v-if="additional_service_list && additional_service_list.filter(item => item.num > 0).length > 0 || productCategory && productCategory.length && productCategory.filter(item => { if (getOrgSelectNum(item) > 0) { return item } }).length > 0
          " class="card-title">
            Additional service
          </div>
          <!-- 免费 -->
          <div class="card"
            v-if="additional_service_list && additional_service_list.filter(item => item.num > 0).length">
            <div class="card-content is-hidden-mobile">
              <div class="tips">
                *Payment is subject to actual arrival at the store.
              </div>
              <div>Estimated ${{ additionalTotal }}</div>
            </div>
            <div class="is-hidden-tablet">
              <div class="tips">
                *Payment is subject to actual arrival at the store.
              </div>
              <div style="text-align: right">Estimated ${{ additionalTotal }}</div>
              <hr color="#eee" size="0.5" style="margin: 5px 0px;" />
            </div>
            <!-- 免费 -->
            <div class="scrollWrap">
              <div class="card-content is-hidden-mobile"
                v-for="(item, index) in additional_service_list.filter(item => item.num > 0)"
                :key="`${index}hiddenMobile`">
                <div class="flex">
                  <!-- 有折扣 -->
                  <div v-if="
                    item &&
                    item.activity_discount &&
                    item.activity_discount.discount
                  ">
                    <div class="discount_price">
                      ${{
                      (
                      (Number(item.price) *
                      (100 - item.activity_discount.discount)) /
                      100
                      ).toFixed(2)
                      }}
                    </div>
                    <div class="org_price">${{ item.price }}</div>
                    <div class="discount">
                      -{{ item.activity_discount.discount }}%
                    </div>
                  </div>
                  <!-- 无折扣 -->
                  <div v-else>${{ item.price }}</div>

                  / {{ item.name }}
                </div>
                <div>
                  {{ item.num }} selected
                </div>
              </div>
              <div class="card-content-tablet is-hidden-tablet"
                v-for="(item, index) in additional_service_list.filter(item => item.num > 0)" :key="index">
                <div class="flex">
                  <!-- 有折扣 -->
                  <div v-if="
                    item &&
                    item.activity_discount &&
                    item.activity_discount.discount
                  ">
                    <div class="discount_price">
                      ${{
                      (
                      (Number(item.price) *
                      (100 - item.activity_discount.discount)) /
                      100
                      ).toFixed(2)
                      }}
                    </div>
                    <div class="org_price">${{ item.price }}</div>
                    <div class="discount">
                      -{{ item.activity_discount.discount }}%
                    </div>
                  </div>
                  <!-- 无折扣 -->
                  <div v-else>${{ item.price }}</div>

                </div>
                <div>{{ item.name }}</div>
                <div>
                  {{ item.num }} selected
                </div>
                <hr color="#eee" size="0.5" style="margin: 5px 0px;" />
              </div>
            </div>
          </div>
          <!-- 收费 -->
          <div class="card"
            v-if="productCategory.length && productCategory.filter(item => { if (getOrgSelectNum(item) > 0) { return item } }).length > 0">
            <div class="text-r">
              Payment ${{ getAllSelectPaymentTotal() }}
              <span v-if="getAllSelectPaymentTotal() != getAllSelectPaymentBeforeRateTotal()" class="org_price">
                ${{ getAllSelectPaymentBeforeRateTotal() }}
              </span>
            </div>
            <div class="scrollWrap">
              <template v-for="(item, index) in productCategory">
                <div class="card-content" :key="index" v-if="getOrgSelectNum(item) > 0">
                  <div>{{ item.name }}</div>
                  <div>
                    {{ getOrgSelectNum(item) || 0 }} selected, ${{ item.paymentTotalTrue || 0 }}
                    <!-- 优惠前金额 -->
                    <span v-if="item.paymentTotalTrue != item.orgPaymentTotalTrue" class="org_price">
                      ${{ item.orgPaymentTotalTrue }}
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 10px">
          <div class="card-title">Remark</div>
          <div>
            <el-input v-model="remark" placeholder="order's remark ..." size="medium" type="textarea"
              white-space="pre-line" @change="changeRemark" />
          </div>
        </div>
      </el-col>
      <!-- 右侧数据显示 -->
      <el-col :lg="10" :md="10" :sm="24" :xl="10" :xs="24">
        <div class="LEVEL-DETAIL" :style="`background: ${color}`">
          <div class="level-name">{{ detail && detail.title }}</div>
          <div class="flex space_between is-hidden-mobile">
            <div>{{ book_date_mm }} {{ checkTimeText }}</div>
            <div>
              <!-- deposit $50.00 -->
              {{
              form.payment_id.indexOf("deposit") > -1
              ? "deposit"
              : "pay in full"
              }}
              <span v-if="form.payment_id.indexOf('deposit') > -1">
                ${{ getPartyPrice() }}
              </span>
              <span v-else>
                <span v-if="activity_discount.discount">
                  <span class="discount_price">${{
                    (
                    (getPartyPrice() * (100 - activity_discount.discount)) /
                    100
                    ).toFixed(2)
                    }}</span>
                  <span class="org_price">${{ getPartyPrice() }}</span>
                </span>
                <span v-else> ${{ getPartyPrice() }} </span>
              </span>
            </div>
          </div>
          <div class="is-hidden-tablet">
            <div>{{ book_date_mm }} {{ checkTimeText }}</div>
            <div>
              {{
              form.payment_id.indexOf("deposit") > -1
              ? "deposit"
              : "pay in full"
              }}
            </div>
            <div>
              <!-- deposit $50.00 -->
              <span v-if="form.payment_id.indexOf('deposit') > -1">
                ${{ getPartyPrice() }}
              </span>
              <span v-else>
                <span v-if="activity_discount.discount">
                  <span class="discount_price">${{
                    (
                    (getPartyPrice() * (100 - activity_discount.discount)) /
                    100
                    ).toFixed(2)
                    }}</span>
                  <span class="org_price">${{ getPartyPrice() }}</span>
                </span>
                <span v-else> ${{ getPartyPrice() }} </span>
              </span>
            </div>
          </div>
          <div>{{ getTableclothColorInfoColor() }} tablecloth</div>
          <div class="HR"></div>
          <div>
            <!-- 收费选择产品 -->
            <div v-for="(citem, cindex) in productCategory" :key="cindex">
              <div v-if="getOrgSelectNum(citem) > 0" class="flex mb4 space_between align-item-center is-hidden-mobile">
                <div class="flex align-item-center">
                  {{ citem.name }} ({{ getOrgSelectNum(citem) }})
                </div>
                <div>
                  ${{ citem.paymentTotalTrue }}
                  <!-- 优惠前金额 -->
                  <span v-if="citem.paymentTotalTrue != citem.orgPaymentTotalTrue" class="org_price">
                    ${{ citem.orgPaymentTotalTrue }}
                  </span>
                </div>
              </div>
              <div v-if="getOrgSelectNum(citem) > 0" class="align-item-center is-hidden-tablet">
                <div class="flex align-item-center">
                  {{ citem.name }} ({{ getOrgSelectNum(citem) }})
                </div>
                <div>
                  ${{ citem.paymentTotalTrue }}
                  <!-- 优惠前金额 -->
                  <span v-if="citem.paymentTotalTrue != citem.orgPaymentTotalTrue" class="org_price">
                    ${{ citem.orgPaymentTotalTrue }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="HR"
            v-if="productCategory.filter(item => { if (getOrgSelectNum(item) > 0) { return item } }).length > 0"></div>
          <div>
            <div v-for="(item, index) in additional_service_list" :key="index" class="mb4">
              <div v-if="item.num > 0" class="flex space_between is-hidden-mobile">
                <div class="flex">
                  <div>${{ item.price }}</div>
                  / {{ item.name }} ({{ item.num }})
                </div>
                <div>Pay in store</div>
              </div>
              <div v-if="item.num > 0" class="is-hidden-tablet">
                <div class="flex">
                  <div>${{ item.price }}</div>
                </div>
                <div>{{ item.name }} ({{ item.num }})</div>
                <div>Pay in store</div>
                <hr color="#eee" size="0.5" style="margin: 5px 0px;" />
              </div>
            </div>
            <div class="tips" v-if="
              additional_service_list.filter(item => item.num > 0).length > 0
            ">
              *Payment is subject to actual arrival at the store.
            </div>
          </div>
          <div class="HR" v-if="
            additional_service_list.filter(item => item.num > 0).length > 0
          "></div>
          <div class="flex total space_between">
            <!-- 展示party价格 + 付费商品价格 -->
            <span class="title">Subtotal</span>
            <div v-if="
              activity_discount.discount || getAllSelectPaymentBeforeRateTotal() != getAllSelectPaymentTotal()
            ">
              <!-- party只交定金 -->
              <span v-if="form.payment_id.indexOf('deposit') > -1" class="discount_price">
                ${{
                (
                Number(getPartyPrice() || 0) + Number(getAllSelectPaymentTotal() || 0)
                ).toFixed(2)
                }}
              </span>
              <span v-else class="discount_price">
                <!-- 全额交party金额，则需要party * 折扣 -->
                ${{
                (
                Number(getPartyPrice() || 0) *
                ((100 - (activity_discount.discount || 0)) / 100).toFixed(
                2
                ) +
                Number(getAllSelectPaymentTotal() || 0)
                ).toFixed(2)
                }}
              </span>
              <span class="org_price" v-if="
                form.payment_id.indexOf('deposit') == -1 ||
                getAllSelectPaymentBeforeRateTotal() != getAllSelectPaymentTotal()
              ">
                ${{
                (Number(getPartyPrice()) + Number(getAllSelectPaymentBeforeRateTotal())).toFixed(2)
                }}
              </span>
            </div>
            <div v-else>
              ${{
              (Number(getPartyPrice()) + Number(getAllSelectPaymentTotal())).toFixed(2)
              }}
            </div>
          </div>
          <div class="flex total space_between">
            <!-- 税费 -->
            <span class="title">Taxes</span>
            <div>${{ getTaxes("Taxes") }}</div>
          </div>
          <div class="flex total space_between">
            <!-- 加税后后总价格 -->
            <span class="title">Total</span>
            <div>${{ getTaxes("total") }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      default: {},
      type: Object
    },
    paymentInfo: {
      default: [],
      type: Array
    },
    activity_discount: {
      default: {},
      type: Object
    },
    detail: {
      default: {},
      type: Object
    },
    additional_service_list: {
      default: [],
      type: Array
    },
    productCategory: {
      default: [
      ],
      type: Array
    },
    additionalTotal: {
      default: 0,
    },
    provideInfo: {
      default: [],
      type: Array
    },
    book_date_mm: {
      default: "",
      type: String
    },
    checkTimeText: {
      default: "",
      type: String
    },
    tableclothColorInfo: {
      default: [],
      type: Array
    },
    // tablecloth_color_id: {
    //   default: '',
    //   type: String
    // },
    product_payment_list: {
      default: [],
      type: Array
    },
    color: {
      default: "",
      type: String
    },
    config: {
      default: {},
      type: Object
    }
  },
  data() {
    return {
      remark: null,
    };
  },
  async created() { },
  methods: {
    // 获取party价格
    getPartyPrice() {
      if (
        this.paymentInfo &&
        this.paymentInfo.find(item => item.id == this.form.payment_id)
      ) {
        return Number(
          this.paymentInfo.find(item => item.id == this.form.payment_id).price
        );
      } else {
        return 0;
      }
    },
    // 获取真正保存后选中的数量总和
    getOrgSelectNum(selectProductInfo) {
      if (selectProductInfo.orgchildren && selectProductInfo.orgchildren.length) {
        var children = selectProductInfo.orgchildren;
        var total = children.reduce((sum, item) => Number(sum) + Number(item.num || 0), 0);
        return total;
      }
    },
    // 获取所有分类选中后的付款价格
    getAllSelectPaymentTotal() {
      var total = 0;
      this.productCategory.map(item => {
        total += Number((item.paymentTotalTrue || 0))
      })
      return total.toFixed(2);
    },
    // 获取所以分类选中后的初始价格，折扣前数据
    getAllSelectPaymentBeforeRateTotal() {
      var total = 0;
      this.productCategory.map(item => {
        total += Number((item.orgPaymentTotalTrue || 0))
      })
      return total.toFixed(2);
    },
    getTaxes(type) {
      var subtotal = 0;
      var orgPrice = 0;
      if (this.activity_discount.discount || this.getAllSelectPaymentTotal() != this.getAllSelectPaymentBeforeRateTotal()) {
        if (this.form.payment_id.indexOf('deposit') > -1) {
          subtotal = (Number(this.getPartyPrice() || 0) + Number(this.getAllSelectPaymentTotal() || 0)).toFixed(2);
        } else {
          subtotal = (Number(this.getPartyPrice() || 0) * ((100 -
            (this.activity_discount.discount || 0)) /
            100).toFixed(2) + Number(this.getAllSelectPaymentTotal() || 0)).toFixed(2)
        }
        if (this.form.payment_id.indexOf('deposit') == -1 || (this.getAllSelectPaymentTotal() != this.getAllSelectPaymentBeforeRateTotal())) {
          orgPrice = (Number(this.getPartyPrice()) + Number(this.getAllSelectPaymentBeforeRateTotal())).toFixed(2)
        }
      } else {
        subtotal = (Number(this.getPartyPrice()) + Number(this.getAllSelectPaymentBeforeRateTotal())).toFixed(2)
      }

      var tax = (subtotal * Number(this.config.tax_rate) / 100).toFixed(2);

      var total = (Number(subtotal) + Number(tax)).toFixed(2);
      if (type == 'Taxes') {
        return tax;
      }
      if (type == 'total') {
        return total;
      }
    },
    getProvideInfoTitle() {
      if (
        this.provideInfo.find(item => item.id == this.form.party_provide_id)
      ) {
        return this.provideInfo.find(
          item => item.id == this.form.party_provide_id
        ).title;
      }
    },
    getTableclothColorInfoColor() {
      if (
        this.tableclothColorInfo.find(
          item => item.id == this.form.tablecloth_color_id
        )
      ) {
        return this.tableclothColorInfo.find(
          item => item.id == this.form.tablecloth_color_id
        ).color;
      }
    },
    // 修改remark
    changeRemark(e) {
      this.$emit("getRemark", e);
    }
  }
};
</script>

<style scoped>
.card-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
}

.card {
  border-radius: 0%;
  border: 1px solid #eee;
  padding: 10px;
  margin-top: 10px;
}

.card div {
  line-height: 30px;
}

.card-content {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex {
  display: flex;
}

.flex div {
  white-space: normal;
  line-height: 30px;
}

.align-item-center {
  align-items: center;
}

.text-r {
  text-align: right;
}

.org_price {
  margin-left: 8px;
  text-decoration: line-through;
  font-weight: bold;
  color: black;
}

.LEVEL-DETAIL .org_price {
  color: white;
}

.discount {
  margin-left: auto;
  background: #e65137;
  color: white;
  margin-left: 8px;
  padding: 0px 6px;
  margin-right: 8px;
}

.discount_price_1 {
  margin-left: 5px;
}

.org_price_1 {
  margin-left: 5px;
  text-decoration: line-through;
  font-weight: bold;
  color: black;
}

.space_between {
  justify-content: space-between;
}

.tips {
  font-size: 12px;
}

.total {
  margin-top: 10px;
}

.total .title {
  font-size: 18px;
  font-weight: bold;
}

/deep/ .dialog-footer {
  display: block !important;
  padding: 10px 20px !important;
  text-align: right !important;
}

.ml10 {
  margin-left: 10px;
}

.time-sigle-disibled {
  background: #ccc;
  pointer-events: none;
}

.mb4 {
  margin-bottom: 4px;
}

@media screen and (min-width: 769px) {
  .scrollWrap {
    max-height: 400px;
    overflow-y: scroll;
    padding-right: 7px;
  }

  /*定义滚动条的整体样式使其变窄*/
  .scrollWrap::-webkit-scrollbar {
    width: 4px;
    height: 1px;
  }

  /*定义滚动条的滑块的样式有圆角和阴影以及自定义的背景色*/
  .scrollWrap::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #d3d5d6;
  }

  /*定义滚动条所在轨道的样式。有圆角和阴影以及淡色系的背景色*/
  .scrollWrap::-webkit-scrollbar-track {
    border-radius: 4px;
  }
}

.month_wrap /deep/ .el-form-item__content {
  margin-left: 0px !important;
}

.tips {
  color: red;
  font-size: 12px;
  line-height: 24px;
}

.product-category-img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.product-category-wrap {
  display: flex;
}

.product-category-card-content {
  padding: 20px 30px;
}

.product-category-title {
  text-align: center;
}

.product-category-select-num {
  text-align: right;
}

.product-category-select-total {
  text-align: right;
}

.align-items-center {
  align-items: center;
}

.selected-info {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.selected-btn {
  text-align: center;
  margin-top: 10px;
}

.LEVEL-DETAIL {
  color: #fff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
  margin-bottom: 10px;
}

.level-name {
  font-size: 32px;
  line-height: 1;
  margin: 0.4em 0;
}

.HR {
  margin: 16px -0.25em;
  border: 1px solid;
}
.mr10 {
  margin-right: 10px;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px),
print {
  .is-hidden-tablet {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page3.vue